<template>
  <div>
    <input
      :id="id"
      v-model="selectedRadio"
      type="radio"
      :name="groupName"
      :value="value"
      class="[&:checked+label]:halebop-focus-rounded"
    />
    <label
      :for="id"
      :class="[
        classes,
        'flex',
        'justify-center',
        'p-16',
        'rounded-md',
        'align-center',
        'cursor-pointer',
        'border-border-primary',
        'border-md',
        'border-solid',
        'bg-surface-action-2',
        'shadow-button',
        'hover:bg-surface-action-hover',
        'active:bg-surface-secondary',
      ]"
      :aria-label="ariaLabel"
    >
      <p
        v-if="simpleLabel && !$slots['simple-label-replacement']"
        class="heading-xs"
      >
        {{ label }}
      </p>
      <span v-else-if="simpleLabel && $slots['simple-label-replacement']">
        <slot name="simple-label-replacement" />
      </span>
      <span
        v-else-if="!simpleLabel"
        class="flex w-full justify-between advanced-label text-text-primary"
      >
        <span class="flex flex-col self-center">
          <slot name="name-advanced" />
        </span>
        <span class="flex flex-col self-center items-end">
          <slot name="price-advanced" />
        </span>
      </span>
    </label>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  label?: string;
  ariaLabel?: string;
  value?: string;
  groupName?: string;
  id: string;
  simpleLabel?: boolean;
  classes?: string;
}

withDefaults(defineProps<Props>(), {
  label: '',
  ariaLabel: undefined,
  value: '',
  groupName: 'radioknappar',
  simpleLabel: true,
  classes: '',
});
const selectedRadio = defineModel<string>();
</script>
<style scoped lang="scss">
label:active {
  * {
    color: var(--text-on-highlight) !important;
  }
}
input {
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 0.1rem;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
  &:focus + label {
    @apply outline outline-2 outline-border-highlight outline-offset-input;
  }
  &:checked {
    + label {
      background-color: var(--surface-action-1);
      border: 2px solid var(--border-primary);
      box-shadow: 1px 1px 0 var(--outer-hard-shadow);
      * {
        color: var(--text-on-highlight) !important;
        &:before {
          background: linear-gradient(
            to left top,
            transparent 45.5%,
            var(--text-on-highlight) 47.5%,
            var(--text-on-highlight) 52.5%,
            transparent 54.5%
          ) !important;
        }
      }
    }
  }
}
</style>
